import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";


export const zoneListStyle = StyleSheet.create({
    parent:
        { flex: 1, backgroundColor: appColors.lightBackgroundColor },
    headerChild:
        { flexDirection: 'row', alignItems: 'center', marginTop: 10, marginHorizontal: 5 },
    addZone:
        { flexDirection: 'row', justifyContent: 'space-between', paddingHorizontal: 5 },
    filterBtn:
        { flexDirection: 'row', alignItems: 'center', paddingHorizontal: 10, backgroundColor: appColors.lightBackgroundColor, marginHorizontal: 5, borderRadius: 10, borderWidth: 1, borderColor: appColors.lightGrey },
    loadWrap:
        { flex: 1, justifyContent: 'center', alignItems: 'center' },
    flex:
        { flex: 1 },
    addEditWrap:
        { flex: 1, alignItems: "center", backgroundColor: appColors?.transparentBackground, },
    listCon:
        { paddingHorizontal: 10, backgroundColor: appColors.light, marginVertical: 10, paddingVertical: 10, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', borderRadius: 10, marginHorizontal: 10 },
    row:
        { flexDirection: 'row' },
    badge:
    {
        color: appColors.lightDark, fontFamily: appFonts.bold, fontSize: fontSize.badgeFontSize, paddingHorizontal: 8, textAlign: 'center'
    },
    badgeCon:
        { justifyContent: 'center', marginLeft: 7 },
    icnCon:
        { paddingHorizontal: 10, paddingVertical: 10, backgroundColor: appColors.lightBackgroundColor, marginHorizontal: 10, borderRadius: 5, },



})